import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';

import { Autocomplete, Button, Table, TableBody, TableCell, TableContainer, TableRow, TextField } from '@mui/material';
import { LoadingButton } from "@mui/lab";

import { useEnumApi } from 'contexts/EnumApiContext';
import { getCompanyInfoAll } from 'components/axios/joinAxios';

import { modals } from 'components/modals/Modals'; 
import useModals from 'components/modals/useModal';
import CustomFormEnumSelect from 'components/select/CustomFormEnumSelect';
import AddressSearchSwitcher from 'components/layer/AddressSearchSwitcher';
import { extensionCheck, ROLE, truncate } from "data/data";
import { getCompanyInfoExistsByQuery, postCompany } from 'components/axios/companyAxios';

const CompanyUserAddSetting = () => {
    const { getEnumValueByEnumName, loginInfo } = useEnumApi();
    const { t } = useTranslation();
    const platformServer   = process.env.REACT_APP_PLATFORM_SERVER;
    const timezone      = (process.env.REACT_APP_TIMEZONE || 'Asia/Seoul').toLowerCase();

    // modal 관련
    const { openModal } = useModals();
    const handleAlertClick = (alertMessage) => {
        openModal(modals.alertModal, {
            onClose : () => {
            },
            message: alertMessage,
        });
    };

    const qs = queryString.parse(window.location.search);
    const searchParam = '?searchField='+(qs?.searchField||'')+'&searchKeyword='+(qs?.searchKeyword||'')+'&searchType='+(qs?.searchType||'')+'&searchStatus='+(qs?.searchStatus||'')
    +'&page='+(qs?.page||'')+'&size='+(qs?.size||'');
    
    const [addressInfo, setAddressInfo] = useState({});
    const [companies, setCompanies] = useState([]);
    const [selectCompany, setSelectCompany] = useState(null);
    const isReadOnly = !!selectCompany; // 선택된 항목이 있으면 true
// console.log('isReadOnly',isReadOnly)
    useEffect(()=> {
        const fetchCompanies = async () => {
            try {
                const res = await getCompanyInfoAll();
                if (res) setCompanies(res);
            } catch (e) {
                console.error(e);
                setCompanies([]);
            }
        };
        fetchCompanies();
    }, []);
   
    const { control, register, handleSubmit, watch, reset, setValue, formState : {isDirty, errors } } = useForm({
        defaultValues: {
            companyType: '', // 또는 기본 선택될 값
        }
    });

    const [businessRegFile, setBusinessRegFile] = useState(null);
    // const [isBusinessRegNoCheck, setIsBusinessRegNoCheck] = useState(false);
    // const [businessRegNo, setBusinessRegNo] = useState('');
    const [logoFile, setLogoFile] = useState(null);
    const [fileLoading, setFileLoading] = useState(false);
    
    // companyType 필드의 값을 실시간으로 감시
    const selectedCompanyType = watch('companyType');
    // 관리주체('MAN')일 때만 주소를 필수값으로 설정
    const isAddressRequired = selectedCompanyType === 'MAN';
// console.log(isAddressRequired)
    // 등록
    const onSubmit = async(data) => {
        setFileLoading(true);
        console.log(data);
    
        const companyId         = data.info.id;
        const companyType       = data.companyType;
        const businessName      = data.info.name;
        const address           = data.address;
        const businessContact   = data.businessContact;
        const businessRegNo     = data.businessRegNo;
        const domain            = data.domain;

        if (domain) {
            getCompanyInfoExistsByQuery({domain}).then((data)=>{
                if (data) {
                    handleAlertClick(t('message.common.alert.domain.use'));
                    setFileLoading(false);
                    return;
                }
            }).catch((err)=>{
                console.log(err);
                handleAlertClick(err.response?.data?.message || err.message);
                setFileLoading(false);
                return;
            })
        }
    
        let dto = {};
        let formData = new FormData();
        if (companyId) {
            dto = {
                type: companyType,
                info : {
                    id : companyId
                },
            }

            if (selectedCompanyType === 'MAN' && !selectCompany?.address) {
                dto.info.address = address;
                // if (appLanguage === 'zh-cn') {
                if (timezone === ('Asia/Shanghai').toLowerCase()) {
                    dto.info.chinaRegionCode = addressInfo?.chinaRegionCode ?? null;
                } else {
                    dto.info.latitude = addressInfo?.lat ?? null;
                    dto.info.longitude = addressInfo?.lng ?? null;
                }
            }
        } else {
            dto = {
                type: companyType,
                info : {
                    domain: domain,
                    businessRegNo: businessRegNo,
                    name: businessName,
                    address: address,
                    contact: businessContact,
                    // latitude : addressInfo?.lat,
                    // longitude : addressInfo?.lng
                }
            }

            // if (appLanguage === 'zh-cn') {
            if (timezone === ('Asia/Shanghai').toLowerCase()) {
                dto.info.chinaRegionCode = addressInfo?.chinaRegionCode ?? null;
            } else {
                dto.info.latitude = addressInfo?.lat ?? null;
                dto.info.longitude = addressInfo?.lng ?? null;
            }
        }
        // if (domain) {
        //     dto.info.domain = domain;
        // }
// console.log(selectCompany)
        if (selectCompany !== null && selectCompany?.companies?.filter(c=>c.type === companyType).length > 0) {
            handleAlertClick(t('message.common.alert.company.exist'));
            setFileLoading(false);
            return;
        }

        if (platformServer !== 'NANTONG') { // 난퉁에서는 구역을 역정보로 사용하니까 기본구역을 추가하지 않는다.
            if (companyType === 'MAN' && (companyId == null || selectCompany?.companies?.filter(c=>c.type === 'MAN').length === 0)) { // 관리주체로 업체정보를 등록하면서 해당 업체가 관리주체로 등록된 적이 없는 경우에만 기본 구역 정보 추가
                let zone = {
                    name : t('message.common.text.default'), 
                    address : addressInfo?.address_name,
                    // latitude : addressInfo?.lat,
                    // longitude : addressInfo?.lng
                }
                // if (appLanguage === 'zh-cn') {
                if (timezone === ('Asia/Shanghai').toLowerCase()) {
                    zone.chinaRegionCode = addressInfo?.chinaRegionCode ?? null;
                } else {
                    zone.latitude = addressInfo?.lat ?? null;
                    zone.longitude = addressInfo?.lng ?? null;
                }
                dto.equipmentZones = [zone]
            }
        }
        formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );
        console.log(dto);

        if (logoFile) {
            if (!extensionCheck(logoFile.name, "I")) {
                handleAlertClick(t('message.common.alert.file.not.match.type'));
                setFileLoading(false);
                return;
            }
            formData.append("logoFile", logoFile);
        }

        if (businessRegFile) {
            formData.append("businessRegFile", businessRegFile);
        }

        openModal(modals.confirmModal, {
            onSubmit : (value) => {
                postCompany(formData).then((res)=>{
                    console.log(res);
                    handleAlertClick(t('message.common.alert.write.done'));
                    setFileLoading(false);
                    window.location.href = '/setting/company/company-user'+searchParam;
                }).catch((err)=>{
                    console.log(err);
                    handleAlertClick(err.response?.data?.message || err.message);
                    setFileLoading(false);
                });
            },
            onClose : () => {
                setFileLoading(false);
                console.log('close');
            },
            message: t('message.common.alert.write.question'),
        });
        
    };

    const [domainCheckStr, setDomainCheckStr] = useState('');
    const dupleCheckDomain = (domain) => {
        if (domain) {
            getCompanyInfoExistsByQuery({domain}).then((data)=>{
                if (data) {
                    setDomainCheckStr(t('message.common.alert.domain.use'));
                // } else {
                //     setDomainCheckStr(t('message.common.alert.id.available'));
                } else {
                    setDomainCheckStr('')
                }
            }).catch((err)=>{
                console.log(err);
                handleAlertClick(err.response?.data?.message || err.message);
            })
        } else {
            setDomainCheckStr('')
        }
    }

    return(
        <div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <TableContainer>
                <Table sx={{ minWidth: 1000 }} aria-label="simple table" className="same_width" style={{borderTop:"2px solid #a2a2a2"}} >
                    <TableBody>
                    <TableRow>
                        <TableCell className="th" style={{width:"250px"}}>
                            {t('message.common.subtitle.company.type')} *
                        </TableCell>
                        <TableCell colSpan={3} style={{textAlign: "left"}}>
                            <Controller
                                sx={{ m: 1, minWidth: "250px" }}
                                name="companyType"
                                control={control}
                                defaultValue={''}
                                rules={{ required: true }}
                                render={({ field:{ onChange, value, name }}) => (
                                    <CustomFormEnumSelect
                                        style={{ minWidth: '250px', margin:"8px" }}
                                        label={t('message.common.subtitle.company.type')}
                                        register={register}
                                        name={name}
                                        value={value}
                                        onChange={onChange}
                                        // requiredMessage={t('message.common.error.text.company.type.select')}
                                        // key={'companyType'}
                                        list={platformServer === 'NANTONG' ? getEnumValueByEnumName('CompanyType')?.filter(data=>data.code !== 'MAN') : getEnumValueByEnumName('CompanyType')}
                                    />
                                )}
                            />
                            {errors.companyType && <small role="alert"><br></br>{errors.companyType.message}</small>}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="th">
                            {t('message.common.subtitle.company.name')} *
                        </TableCell>
                        <TableCell colSpan={3} style={{textAlign: "left"}}>
                            <Controller
                                name="info"
                                control={control}
                                defaultValue={null}   // ✅ undefined 방지
                                rules={{ 
                                    required: t('message.common.error.text.company.name.input'),
                                }}
                                render={({ field, fieldState }) => (
                                    <Autocomplete
                                    disablePortal
                                    style={{width: "90%"}}
                                    {...field}
                                    value={field.value || null}   // ✅ 항상 null 또는 객체
                                    freeSolo
                                    options={companies ?? []}
                                    getOptionLabel={(option) => {
                                        if (!option) return "";
                                        if (typeof option === "string") return option;               // freeSolo 입력값
                                        if (option.inputValue) return option.inputValue;             // 새 값 추가 처리
                                        return `${option.name}${option.address ? `, ${truncate(option?.address ?? "", 10)}` : ""}`;
                                    }}
                                    onChange={(event, value) => {
                                        // console.log(value)
                                        // value가 객체면 기존 업체 선택, 문자열이면 새 업체 등록
                                        if (typeof value === "string") {
                                            field.onChange({ id: null, name: value, address: "" }); // 새 업체명
                                        } else if (value && value.inputValue) {
                                        // createOption 패턴 (입력값 기반 새 객체)
                                            field.onChange({ id: null, name: value.inputValue, address: "" });
                                        } else {
                                            // console.log(3)
                                            field.onChange(value); // 기존 객체
                                            console.log(value)
                                            if (value) {
                                                setSelectCompany(value);
                                                setValue("address", value.address);
                                                setValue("businessContact", value.contact);
                                                setValue("businessRegNo", value.businessRegNo);
                                                // if (appLanguage === 'zh-cn') {
                                                if (timezone === ('Asia/Shanghai').toLowerCase()) {
                                                    setAddressInfo({address_name: value.address, chinaRegionCode:value.chinaRegionCode ?? null})
                                                } else {
                                                    setAddressInfo({address_name: value.address, lat:value.latitude ?? null, lng:value.longitude ?? null})
                                                }
                                            }
                                        }
                                    }}
                                    onInputChange={(_, newInputValue, reason) => {
                                        // console.log(1)
                                        if (reason === "input") {
                                            field.onChange({id:null, name:newInputValue}); // 타이핑 값도 그대로 저장
                                            // field.onChange(newInputValue); // 타이핑 값도 그대로 저장
                                            setSelectCompany(null);
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                        {...params}
                                        sx={{ m: 1, minWidth: '80%' }} 
                                        label={t('message.common.text.search.company.name')}
                                        error={!!fieldState.error}
                                        />
                                    )}
                                    />
                                )}
                            />
                            {errors.info && <small role="alert"><br></br>{errors.info.message}</small>}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="th">
                            {t('message.common.subtitle.address')} {isAddressRequired && <>*</>}
                            {/* {console.log(selectCompany)} */}
                        </TableCell>
                        <TableCell colSpan={3} style={{textAlign: "left"}}>
                            {!selectCompany?.id || (selectedCompanyType === 'MAN' && !selectCompany?.address) ?
                            <>
                            <Controller
                                control={control}
                                name="address"
                                rules={{ 
                                    validate: (value, formValues) => {
                                        if (formValues['companyType'] === 'MAN' &&
                                            (value === null || value === undefined || value === '')) {
                                            return t('message.common.error.text.address.input');
                                        }
                                        return true;
                                    }
                                }}
                                render={({ field, fieldState }) => (
                                <AddressSearchSwitcher register={register} setValue={setValue} field={field} fieldState={fieldState} 
                                    errors={errors} setAddressInfo={setAddressInfo} objName={'address'} addressInfo={addressInfo} />
                                )}
                            />
                            <Button variant="outlined" color="error" style={{marginTop:"10px"}} 
                                onClick={()=>{
                                    setValue("address", "");
                                    setAddressInfo({address_name: "", lat:"", lng:"", chinaRegionCode: ""})
                                }}
                            >X</Button>
                            {errors.address && <small role="alert"><br></br>{errors.address.message}</small>}
                            </>
                            :
                            <TextField id="address" 
                                {...register("address", {
                                })} 
                                InputProps={{ readOnly: isReadOnly }}
                                sx={{ m: 1, minWidth: '90%' }} 
                            />
                            }
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="th">
                            {t('message.common.subtitle.company.contact')}
                        </TableCell>
                        <TableCell colSpan={3} style={{textAlign: "left"}}>
                            <TextField id="businessContact" 
                            {...register("businessContact", {
                            })} 
                            InputProps={{ readOnly: isReadOnly }}
                            sx={{ m: 1, minWidth: '90%' }} />
                        </TableCell>
                    </TableRow>
                    {loginInfo.role === ROLE.SA.code && 
                    <TableRow>
                        <TableCell className="th">
                            {t('message.common.subtitle.company.domain')}
                        </TableCell>
                        <TableCell colSpan={3} style={{textAlign: "left"}}>
                            <TextField id="domain" 
                            {...register("domain", {})} 
                            sx={{ m: 1, minWidth: '70%' }}
                            InputProps={{ readOnly: isReadOnly }}
                            onChange={(e)=>{dupleCheckDomain(e.target.value)}}
                            />
                            {domainCheckStr && <small role="alert"><br/>{domainCheckStr}</small>}
                            <br/>* {t('message.common.text.only.domain.exclude.http')}
                        </TableCell>
                    </TableRow>
                    }
                    <TableRow>
                        <TableCell className="th">
                            {t('message.common.subtitle.business.register.no')}
                        </TableCell>
                        <TableCell colSpan={3} style={{textAlign: "left"}}>
                            
                            <TextField id="businessRegNo" 
                                {...register("businessRegNo", {
                                })} 
                                InputProps={{ readOnly: isReadOnly }}
                                sx={{ m: 1, minWidth: '90%' }}
                            />
                        </TableCell>
                    </TableRow>
                    {selectCompany?.id == null &&
                    <TableRow>
                        <TableCell className="th">
                            {t('message.common.subtitle.business.register.file')}
                        </TableCell>
                        <TableCell colSpan={3} style={{textAlign: "left"}}>
                            <input
                                style={{margin:"8px"}}
                                type="file" 
                                onChange={(e)=>setBusinessRegFile(e.target.files[0])}
                            />
                        </TableCell>
                    </TableRow>
                    }
                    {selectCompany?.id == null &&
                    <TableRow>
                        <TableCell className="th">{t('message.common.subtitle.company.logo')}</TableCell>
                        <TableCell colSpan={3} style={{textAlign: "left"}}>
                            <input
                                style={{margin:"8px"}}
                                type="file" 
                                accept={'.jpg,.jpeg,.png,.gif'}
                                onChange={(e)=>setLogoFile(e.target.files[0])}
                            />
                        </TableCell>
                    </TableRow>
                    }
                    </TableBody>
                </Table>
                </TableContainer>
            </form>

            <div style={{marginTop:"10px",display: "flex",justifyContent: "space-between",}}>
                <div>
                    <Link to={'/setting/company/company-user'+searchParam}><Button variant="contained" color="primary" style={{backgroundColor:"#333"}}>{t('message.common.btn.return')}</Button></Link>
                </div>
                <div>
                    <LoadingButton variant="contained" color="primary" loading={fileLoading} onClick={handleSubmit(onSubmit)}>{t('message.common.btn.write')}</LoadingButton>
                </div>
            </div>
        </div>
    )
}
export default CompanyUserAddSetting;